<div class="container mt-2 mb-0">
  <div class="row justify-content-center my-4">
    <div class="col-12 col-md-8">
      <div class="row rounded pb-3">

        @if(loading()) {
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
          >
          </mat-progress-spinner>
        }
        @else {
          @if(cartError()) {
            <div class="error-section">Error: {{cartError()}}</div>
          }    
          @if(cartCompleted()) {
            <div>This cart is already paid</div>
          }
          @if(!cartError() && !cartCompleted()) {
            <equine-ui-nx-order-summary
              [subtotal]="subTotal()"
              [subtotalCount]="totalItems()"
              [coupon]="coupon()"
              [donation]="donationOrderTotal()"
              [total]="total()"
              (goBack)="goBack()"
            ></equine-ui-nx-order-summary>
          }
        }
      </div>
    </div>

    <div class="col-12 col-md-4">
      <mat-card class="p-0 shadow">
        <mat-card-title class="text-center my-2 pb-1">Proceed to Payment</mat-card-title>
        <hr class="p-0 mb-4 mt-0">
        <div class="row justify-content-center mb-4">
          <div class="col-md-10">
            @if(!cartCompleted() && !cartError() && !linkLoading()) {

              @if(needsAcceptance()) {
                <equine-ui-nx-ach-acceptance
                  (confirmed)="acceptTerms()"
                ></equine-ui-nx-ach-acceptance>
              }
              @else {

                @if (!exchangeToken() && !firstClickAfterAdd() && !errorAfterExchange() && dwollaLink.customerFundingSources && dwollaLink.customerFundingSources.length) {
                  <equine-ui-nx-ach-accounts
                    [accounts]="dwollaLink.customerFundingSources"
                    [loading]="loading() || paying()"
                    (selected)="payWithAccount($event)"
                    (removed)="removeAccount($event)"
                  ></equine-ui-nx-ach-accounts>
                }

                @if(!exchangeToken() && !errorAfterExchange() && !paying()) {
                  <div>
                    @if (!firstClickAfterAdd()) {
                      <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="confirmAddNewAccount()" >
                        ADD NEW ACCOUNT
                      </button>
                    }

                    @else {
                      <div class="exchange-section-approval">
                        <div>You will be redirected to Visa website in order to verify your account</div>
                        <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="createExchangeSession()" [disabled]="loading()">
                          PROCEED TO VERIFICATION
                        </button>
                        <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="cancelAddAccount()" [disabled]="loading()">
                          CANCEL
                        </button>
                      </div>
                    }
                  </div>
                  
                }
  
                @if(errorAfterExchange()) {
                  <div class="error-section">
                    <div class="title">Error:</div>
                    <div>An error occured adding your account. Please try again.</div>
  
                    @if (error === 'AUTHENTICATION_ERROR') {
                      <div>A problem occured with the authentication with your bank</div>
                    }
                    @if (error === 'USER_CANCELLED') {
                      <div>Please don't go back or cancel to add your bank</div>
                    }
                    @if (error === 'TEMPORARY_ERROR') {
                      <div>A temporary error in Visa's platform or a network issue. To resolve any of these errors, try again later.</div>
                    }
  
                    <button mat-raised-button color="primary" class="full-witdh" type="button" (click)="tryAgainAfterError()">
                      DISMISS
                    </button>
                  </div>
                }
  
                @if(exchangeToken()) {
                  <form class="account-section">
                    <mat-label>Account type</mat-label>
                    <mat-form-field class="full-width">
                      <select matNativeControl [formControl]="bankAccountType">
                        <option value="checking">Checking</option>
                        <option value="savings">Savings</option>
                      </select>
                    </mat-form-field>

                    <mat-form-field class="full-width">
                      <mat-label>Account nick name</mat-label>
                      <input type="text" matInput [formControl]="nickName"
                             placeholder="Wells Fargo Jhon Savings">
                    </mat-form-field>
                  </form>
  
                  <button mat-raised-button class="full-witdh" type="button" (click)="addNewAccount()" [disabled]="bankAccountType.invalid || nickName.invalid || loading()">
                    ADD ACCOUNT
                  </button>
                }
              }
            }
          </div>
        </div>
      </mat-card>
    </div>


  </div>

</div>